<template>
  <v-container fluid>
    <v-layout row wrap align-center>
      <v-flex xs12 sm12 md12>
        <v-card>
          <v-layout row>
            <v-card-text class="title">Attendence</v-card-text>
            <v-divider class="my-2" vertical></v-divider>
            <v-spacer />
          </v-layout>
        </v-card>
        <v-card class="px-3">
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <div>
                <!-- color="#0097A7" -->
                <v-tabs color="indigo" dark outline slider-color="#DC30FF" centered>
                  <v-tab><v-icon color="#FFFF00">info</v-icon>&nbsp;&nbsp;View
                    Attendence</v-tab>

                  <v-tab-item>
                    <v-card flat style="padding-top:20px; padding-left:40px; padding-right:40px; padding-bottom:20px;">
                      <v-layout row wrap style="text-align: center;">
                        <v-flex xs12 sm4 style="padding: 10px">
                          <v-text-field v-model="searchParam.exam_roll" type="number" label="Exam Roll Number"
                            prepend-inner-icon="edit">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 style="padding: 10px">
                          <v-text-field v-model="searchParam.paper_code" type="number" label="Paper Code"
                            prepend-inner-icon="edit">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 style="padding: 10px">
                          <v-text-field v-model="searchParam.room_no" type="number" label="Room No"
                            prepend-inner-icon="edit">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 style="padding: 10px">
                          <v-text-field v-model="searchParam.script_sl_no" label="Script Serial Number"
                            prepend-inner-icon="edit" :disabled="!!searchParam.script_qr">
                          </v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout row wrap style="
                          text-align: center;
                          margin-top: -10px;
                          margin-bottom: 10px;
                        ">
                        <v-flex xs12 sm12>
                          <v-btn color="primary" @click="getAttandanceData()">Submit</v-btn>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="text-align: center">
                        <v-flex xs12 sm12>
                          <div class="px-3" style=" margin-bottom: -9px; font-size: x-large;">
                            <b>Attandance status:</b>&nbsp; 
                          </div>
                       <br>

                        <div v-if="getMsg && getMsg.message" class="px-3" :style="{
                          color: getMsg.status === 'success' ? 'green' : 'red',
                          fontSize: 'large'
                        }">
                          <b>{{ getMsg.message }}</b>
                        </div>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="confirmDialog" persistent max-width="500px">
      <v-card style="border-radius:10px">
        <v-toolbar dark color="indigo" class="my-tool pa-1" style flat>
          <v-spacer></v-spacer>
          <v-icon x-large style="font-size: 50px;">info</v-icon>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="title pa-4 text-xs-center">Are you sure that you want to <b style="color: red;">Delete</b>
          this
          attendance?</v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pt-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="primary" flat text @click="deleteAttandance()">
            <div class="title text-xs-center">Yes</div>
          </v-btn>
          <v-spacer></v-spacer>
          <v-divider vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="primary" text flat large @click="close()">
            <div class="title text-xs-center">Cancel</div>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import common_login_getters from "@/mixin/common_login_getters";
import commonExamYear from "../../mixin/exam_year_watch_mixin";
import commonGet from "../../mixin/common_getters_mixin";
// import dragDropImg from "../../assets/images/drag-and-drop.png";

export default {
  mixins: [common_login_getters, commonGet, commonExamYear],
  data() {
    return {
      searchParam: {
        script_sl_no: "",
        script_qr: "",
      },
      selection: {
        active: false,
        mode: "draw", // draw | move | resize
        dir: null,
        startX: 0,
        startY: 0,
        x: 0,
        y: 0,
        w: 0,
        h: 0,
      },
      confirmDialog: false,
      fileName: "",
      imageFile: null,
      imageUrl: "",
      croppedImage: "",
      cropping: false,
      cropDone: false,
      startX: 0,
      startY: 0,
      endX: 0,
      endY: 0,
      apiResult: null,
    };
  },

  mounted() {
    window.addEventListener("paste", this.handlePaste);
  },
  beforeDestroy() {
    window.removeEventListener("paste", this.handlePaste);
  },

  created() {
    //this.getCertificateRegisterPrint();
  },

  computed: {
    getMsg() {
      return this.$store.getters.getAttMsg;
    }
  },

  methods: {
    redo() {
      this.searchParam = {};
      this.getStudentAttendence = "";
    },

    getAttandanceData() {
      let param = {
        exam_code: this.getLoggedInExam.code,
        exam_year: this.getLoggedInYear.year,
        room_no: this.searchParam.room_no,
        exam_roll: this.searchParam.exam_roll,
        paper_code: this.searchParam.paper_code,
        script_sl_no: this.searchParam.script_sl_no,
      };
      console.log("Tanvir! Need To show att...", param);
      const hasRollAndPaper =
        this.searchParam.paper_code &&
        (this.searchParam.exam_roll || this.searchParam.reg_no);

      const hasScript =
        this.searchParam.script_sl_no || this.searchParam.script_qr;

      if (hasRollAndPaper || hasScript) {
        this.$store.dispatch("getAttCheckRs", param).then((data) => {
          console.log("Tanvir! this is ghotona", data);
        });
      }
    },

    MakeAttandance() {
      let param = {
        exam_code: this.getLoggedInExam.code,
        exam_year: this.getLoggedInYear.year,
        exam_roll: this.searchParam.ma_exam_roll,
        paper_code: this.searchParam.ma_paper_code,
        script_sl_no: this.searchParam.ma_script_sl_no,
        room_no: this.searchParam.ma_room_no,
      };
      console.log("Tanvir! Need To save att...", param);
      if (
        this.searchParam.ma_exam_roll &&
        this.searchParam.ma_paper_code &&
        this.searchParam.ma_script_sl_no &&
        this.searchParam.ma_room_no
      ) {
        this.$store.dispatch("saveAandacData", param).then((data) => {
          console.log("Tanvir! this is ghotona", data);
        });
      }
    },

    close() {
      this.confirmDialog = false;
    },
    processDelete() {
      this.confirmDialog = true;
    },
    //  exam_roll: this.getStudentAttendence.data.exam_roll,
    deleteAttandance() {
      let param = {
        exam_code: this.getLoggedInExam.code,
        exam_year: this.getLoggedInYear.year,
        exam_roll: this.getStudentAttendence.data.exam_roll,
        paper_code: this.getStudentAttendence.data.paper_code,
      };
      console.log("Tanvir! Need To delete att...", param);
      this.$store.dispatch("deleteAttendanceData", param).then((data) => {
        (this.getStudentAttendence = ""), (this.confirmDialog = false);
        console.log("Tanvir! this is ghotona", data);
      });
    },

    processImageFile(file, name = "image") {
      if (!file) return;

      this.resetCrop();

      this.fileName = name;
      this.imageFile = file;

      const reader = new FileReader();

      reader.onload = async (e) => {
        this.imageUrl = e.target.result;

        // 🔥 auto QR detect
        await this.autoDetectQrFromImage(this.imageUrl);
      };

      reader.readAsDataURL(file);
    },

    handlePaste(e) {
      const items = e.clipboardData && e.clipboardData.items;
      if (!items) return;

      for (let i = 0; i < items.length; i++) {
        const item = items[i];

        if (item.type.indexOf("image") !== -1) {
          const file = item.getAsFile();
          if (!file) return;

          this.processImageFile(file, "pasted-image.png");
          break;
        }
      }
    },

    handleDrop(e) {
      const files = e.dataTransfer.files;
      if (!files || !files.length) return;

      const file = files[0];

      if (!file.type.startsWith("image/")) {
        alert("Please drop an image file");
        return;
      }

      this.processImageFile(file, file.name);
    },

    autoDetectQrFromImage(src) {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          canvas.width = img.width;
          canvas.height = img.height;

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

          const code = jsQR(imageData.data, imageData.width, imageData.height);

          if (code) {
            this.apiResult = code.data;
            this.searchParam.script_qr = code.data;

            console.log("QR FOUND:", code.data);
          } else {
            this.apiResult = "No QR code found";
            window.alert("No QR detected or multiple QR codes found! please try cropping the image to contain only one QR code.");
          }

          resolve();
        };
      });
    },

    onMouseDown(e) {
      const rect = this.$refs.cropWrapper.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const target = e.target.dataset && e.target.dataset.dir;

      // RESIZE MODE
      if (target) {
        this.selection.mode = "resize";
        this.selection.dir = target;
        this.selection.startX = x;
        this.selection.startY = y;
        return;
      }

      // MOVE MODE
      if (e.target.classList.contains("move-handle")) {
        this.selection.mode = "move";
        this.selection.startX = x;
        this.selection.startY = y;
        return;
      }

      // DRAW MODE
      this.selection.mode = "draw";
      this.selection.active = true;

      this.selection.x = x;
      this.selection.y = y;
      this.selection.w = 0;
      this.selection.h = 0;
    },

    onMouseMove(e) {
      if (!this.selection.mode) return;

      const rect = this.$refs.cropWrapper.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      // DRAW
      if (this.selection.mode === "draw") {
        this.selection.w = x - this.selection.x;
        this.selection.h = y - this.selection.y;
      }

      // MOVE
      if (this.selection.mode === "move") {
        const dx = x - this.selection.startX;
        const dy = y - this.selection.startY;

        this.selection.x += dx;
        this.selection.y += dy;

        this.selection.startX = x;
        this.selection.startY = y;
      }

      // RESIZE
      if (this.selection.mode === "resize") {
        this.resizeBox(x, y);
      }
    },

    onMouseUp() {
      this.selection.mode = null;
    },

    resizeBox(x, y) {
      const sel = this.selection;

      const x2 = sel.x + sel.w;
      const y2 = sel.y + sel.h;

      switch (sel.dir) {
        case "tl":
          sel.x = x;
          sel.y = y;
          sel.w = x2 - x;
          sel.h = y2 - y;
          break;

        case "tr":
          sel.y = y;
          sel.w = x - sel.x;
          sel.h = y2 - y;
          break;

        case "bl":
          sel.x = x;
          sel.w = x2 - x;
          sel.h = y - sel.y;
          break;

        case "br":
          sel.w = x - sel.x;
          sel.h = y - sel.y;
          break;
      }
    },

    pickFile() {
      this.$refs.fileInput.click();
    },

    resetCrop() {
      this.cropping = false;
      this.cropDone = false;

      this.imageFile = null;
      this.imageUrl = "";
      this.fileName = "";

      this.apiResult = null;
      this.searchParam.script_qr = "";

      this.selection = {
        active: false,
        mode: "draw",
        dir: null,
        startX: 0,
        startY: 0,
        x: 0,
        y: 0,
        w: 0,
        h: 0,
      };
    },

    onFilePicked(e) {
      const file = e.target.files[0];
      if (!file) return;

      if (!file.type.startsWith("image/")) {
        alert("Please select an image file");
        return;
      }

      this.processImageFile(file, file.name);

      // reset input so same file can be selected again
      this.$refs.fileInput.value = null;
    },

    startCrop(e) {
      const rect = this.$refs.cropWrapper.getBoundingClientRect();

      this.cropping = true;
      this.cropDone = false;

      this.startX = e.clientX - rect.left;
      this.startY = e.clientY - rect.top;

      this.endX = this.startX;
      this.endY = this.startY;
    },

    moveCrop(e) {
      if (!this.cropping) return;

      const rect = this.$refs.cropWrapper.getBoundingClientRect();

      this.endX = e.clientX - rect.left;
      this.endY = e.clientY - rect.top;
    },

    endCrop() {
      if (!this.cropping) return;

      this.cropping = false;
      this.cropDone = true;
    },

    cropImage() {
      const img = this.$refs.image;
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const scaleX = img.naturalWidth / img.width;
      const scaleY = img.naturalHeight / img.height;

      const x =
        Math.min(this.selection.x, this.selection.x + this.selection.w) *
        scaleX;
      const y =
        Math.min(this.selection.y, this.selection.y + this.selection.h) *
        scaleY;
      const w = Math.abs(this.selection.w) * scaleX;
      const h = Math.abs(this.selection.h) * scaleY;

      canvas.width = w;
      canvas.height = h;

      ctx.drawImage(img, x, y, w, h, 0, 0, w, h);

      canvas.toBlob((blob) => {
        if (!blob) return;

        this.imageUrl = URL.createObjectURL(blob);
        this.imageFile = new File([blob], "cropped.jpg", {
          type: "image/jpeg",
        });

        this.readQrFromImage(blob);

        // reset selection
        this.selection.active = false;
      }, "image/jpeg");
    },

    readQrFromImage(blob) {
      const img = new Image();

      img.src = URL.createObjectURL(blob);

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

        const code = jsQR(imageData.data, imageData.width, imageData.height);

        if (code) {
          this.apiResult = code.data; // 🎯 QR RESULT TEXT
          this.searchParam.script_qr = this.apiResult;
          console.log("QR FOUND:", code.data);
        } else {
          this.apiResult = "No QR code found";
          window.alert("No QR detected or multiple QR codes found! please try cropping the image to contain only one QR code.");
        }
      };
    },
  },
};
</script>

<style scoped>
.attendance-card {
  padding: 20px 40px;
  text-align: center;
}

.attendance-table {
  width: 100%;
  border-collapse: collapse;
  margin: auto;
  font-size: 16px;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
}

.attendance-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #ddd;
  text-align: left;
}

.attendance-table tr:nth-child(even) {
  background-color: #c8f1f6;
}

.attendance-table tr:hover {
  background-color: #c1f9ff;
}

.attendance-table td:first-child {
  font-weight: bold;
  color: #333;
  width: 40%;
}

.attendance-table td:last-child {
  color: #555;
}

.crop-wrapper {
  position: relative;
  display: inline-block;
  user-select: none;
  cursor: crosshair;
}

.crop-image {
  max-width: 100%;
  display: block;

}

.crop-box {
  position: absolute;
  border: 2px solid #ff0000;
  background: rgba(255, 0, 0, 0.12);
}

/* MOVE AREA */
.move-handle {
  position: absolute;
  inset: 0;
  cursor: move;
}

/* RESIZE HANDLES */
.handle {
  width: 10px;
  height: 10px;
  background: #fff;
  border: 2px solid red;
  position: absolute;
}

.handle.tl {
  top: -5px;
  left: -5px;
  cursor: nwse-resize;
}

.handle.tr {
  top: -5px;
  right: -5px;
  cursor: nesw-resize;
}

.handle.bl {
  bottom: -5px;
  left: -5px;
  cursor: nesw-resize;
}

.handle.br {
  bottom: -5px;
  right: -5px;
  cursor: nwse-resize;
}

.upload-box {
  border: 2px dashed #ccc;
  padding: 60px;
  text-align: center;
  transition: all 0.3s ease;
  background-repeat: no-repeat;
  background-position: center 20px;
  background-size: 70px;
}

.upload-box:hover {
  border-color: #1976d2;
}
</style>
